module.exports = __webpack_public_path__ + "static/media/paymentActivity.12fc47d2.jpg";